import { Grid, Skeleton, LinearProgress } from "@mui/material"

export default function BidLoading() {
    return (
        <Grid container spacing={6} flexDirection="column" sx={{marginTop: "-24px"}}>
            <Grid item>
                <LinearProgress />
                <Skeleton variant="rounded" height="80px" sx={{borderRadius: "20px", marginTop: "24px"}} /> 
                
            </Grid>
            <Grid item container spacing={4}>
                <Grid item flexGrow={1}>
                    <Skeleton variant="rounded" height="250px" sx={{borderRadius: "20px"}} />
                </Grid>
                <Grid item flexGrow={1}>
                    <Skeleton variant="rounded" height="250px" sx={{borderRadius: "20px"}} />
                </Grid>
            </Grid>
            <Grid item>
                <Skeleton variant="roundined" height="300px" sx={{borderRadius: "20px"}} />
            </Grid>
        </Grid>
    )
}
